var _jsxFileName = "/repo/packages/webassets/src/components/Header/components/HeaderLogo/index.js",
  _this = this;
import React from 'react';
import PropTypes from 'prop-types';
import { Logo, LogoWithText } from '../../../Logos';
import { TabletScreen, MobileScreen } from '../../../MediaComponents';
import './header-logo.scss';
var HeaderLogo = function HeaderLogo(_ref) {
  var variant = _ref.variant,
    color = _ref.color,
    isUserAuthenticated = _ref.isUserAuthenticated;
  var auth = isUserAuthenticated ? 'auth' : 'anon';
  return /*#__PURE__*/React.createElement("a", {
    href: "/",
    alt: "SurveyMonkey Logo",
    className: "sm-header-logo__".concat(auth, "--").concat(variant, " sm-header-logo__link"),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 5
    }
  }, !isUserAuthenticated ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabletScreen, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(LogoWithText, {
    className: "sm-header-logo__text",
    color: color,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement(MobileScreen, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Logo, {
    color: color,
    className: "sm-header-logo__anon-icon",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 13
    }
  }))) : /*#__PURE__*/React.createElement(Logo, {
    className: "sm-header-logo__auth-icon",
    color: "alt",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 9
    }
  }));
};
HeaderLogo.propTypes = {
  isUserAuthenticated: PropTypes.bool,
  color: PropTypes.oneOf(['primary', 'alt']),
  variant: PropTypes.oneOf(['default', 'limited', 'slim'])
};
HeaderLogo.defaultProps = {
  isUserAuthenticated: false,
  color: 'primary',
  variant: 'default'
};
export default HeaderLogo;
//# sourceMappingURL=index.js.map